<script setup lang="ts">
  import { computed } from "vue";
  import { getFlagByCountryCode } from "@utils/constants/regions";
  import type { HistoCampaign } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    campaigns: Record<string, HistoCampaign[]>;
    isMultiCountry: boolean;
  }>();

  const campaignBaseURL = computed(() => {
    return `${window.location.origin}/admin/m_campaigns`;
  });

  function getCostShare(item: { cost_share?: number }): number {
    if (!item?.cost_share) return 0;
    return Math.round(item.cost_share * 100);
  }
</script>

<template>
  <section>
    <h3 class="heading-section mb-3">Top campaigns</h3>
    <template v-if="Object.keys(campaigns).length">
      <template
        v-for="(items, country) in campaigns"
        :key="country">
        <div
          v-if="isMultiCountry"
          class="mb-2">
          <span class="font-medium text-sm text-foreground">
            {{ getFlagByCountryCode(country as string) }} {{ country }}
          </span>
        </div>
        <ul class="space-y-2 mb-4">
          <li
            v-for="(campaign, idx) in items"
            :key="`campaign-${idx}`"
            class="flex items-center gap-2 text-sm">
            <span class="font-medium text-foreground shrink-0">{{ getCostShare(campaign) }}%</span>
            <a
              :href="`${campaignBaseURL}/${campaign.campaign_token}/setup`"
              target="_blank"
              rel="noopener"
              class="text-status-info-strong hover:underline truncate">
              {{ campaign.campaign_name }}
            </a>
          </li>
        </ul>
      </template>
    </template>
    <p
      v-else
      class="text-sm text-foreground/50 italic">
      No campaigns available
    </p>
  </section>
</template>
